<h1>
  <span [ngSwitch]="code">
    <ng-container *ngSwitchCase="'403'">Forbidden:</ng-container>
    <ng-container *ngSwitchCase="'404'">Not Found:</ng-container>
  </span>
  {{code}}
</h1>
